import { Fragment } from 'react';

import { CustomDialogTitle, CustomDialogContent } from '../../CustomDialog';

const PrivacyPolicy = ({ onClose, content }) => {
  return (
    <Fragment>
      <CustomDialogTitle onClose={onClose}>
        Privacy policy
      </CustomDialogTitle>
      <CustomDialogContent>{content}</CustomDialogContent>
    </Fragment>
  );
};

export default PrivacyPolicy;
